import { render, staticRenderFns } from "./ManageReviewWarehouses.vue?vue&type=template&id=4d5838f1&scoped=true"
import script from "./ManageReviewWarehouses.vue?vue&type=script&lang=js"
export * from "./ManageReviewWarehouses.vue?vue&type=script&lang=js"
import style0 from "./ManageReviewWarehouses.vue?vue&type=style&index=0&id=4d5838f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5838f1",
  null
  
)

export default component.exports